export type Dim =
  | number
  | `${number}px`
  | `${number}pt`
  | `${number}mm`
  | `${number}vw`
  | `${number}vh`
  | `${number}dvh`;

// Conversion constants
export const PT_PER_INCH = 72;
export const MM_PER_INCH = 25.4;
export const PX_PER_INCH = 96;

export function normalizeToPx(
  dim: Dim,
  window?: {
    innerWidth?: number;
    innerHeight?: number;
  },
): number {
  if (typeof dim === 'number') {
    return dim;
  }

  const match = dim.match(/(-?\d*\.?\d+)(px|pt|mm|vw|vh|dvh)/);

  if (!match) {
    throw new Error(`Unsupported dimension format: ${dim}`);
  }

  const [, valueStr, unit] = match;
  const value = parseFloat(valueStr);

  switch (unit) {
    case 'px':
      return value;
    case 'pt':
      return value * (PX_PER_INCH / PT_PER_INCH);
    case 'mm':
      return value * (PX_PER_INCH / MM_PER_INCH);
    case 'vw':
      return (value / 100) * (window?.innerWidth ?? 768);
    case 'vh':
    case 'dvh':
      return (value / 100) * (window?.innerHeight ?? 768);
    default:
      throw new Error(`Unsupported dimension format: ${dim}`);
  }
}

export const BREAKPOINTS = {
  xs: 0,
  sm: 480,
  md: 768,
  lg: 1024,
  xl: 1200,
};
